import {call, put, takeLatest} from 'redux-saga/effects'
import {
    dPosConfigurationAddItemSagaAC,
    dPosConfigurationDeleteItemSagaAC,
    dPosConfigurationEditItemSagaAC, dPosConfigurationGetFullItemSagaAC,
    dPosConfigurationSetDataAC,
    dPosConfigurationSetDataSagaAC, dPosConfigurationSetFullDetailItemAC,
} from './dPosConfigurationActionCreators'
import { dashboardLoaderAC } from '../system/systemActionCreators'
import {
    IdPosConfigurationStateDataItem,
    typePosConfigurationFilters,
} from './dPosConfigurationReducer'
import {
    addPosConfigurationItem,
    deletePosConfigurationItem, editPosConfigurationItem, getPosConfigurationList, getPosFullItem,
} from './dPosConfigurationAPI'
import {typeAddPosConfigurationItemObject} from 'components/containers/dashboard/dataPosConfiguration/popupContents/popupAdd'
import {typeEditPosConfigurationItemObject} from 'components/containers/dashboard/dataPosConfiguration/popupContents/popupEdit'
import { errorGenerator, notificationCreator } from 'model/system/utils';

// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdPosConfigurationStateDataItem[] => {
    return tempResponseData.map((item:IdPosConfigurationStateDataItem) => {
        return(
            {
                id: item.id,
                name: item.name,
                storeIds: item.storeIds,
                posIds: item.posIds,
                posCategories: item.posCategories,
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typePosConfigurationFilters}) {

    let response = yield call(getPosConfigurationList, payload)

    if (response.status === 200) {

        const tempData: IdPosConfigurationStateDataItem[] = tempDataMapper(response.data)

        yield put(dPosConfigurationSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Set product list saga
export function* dPosConfigurationSetDataWorker (actionObject:{type: string, payload: { filters: typePosConfigurationFilters}}) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dPosConfigurationSetDataWatcher () {
    yield takeLatest(dPosConfigurationSetDataSagaAC.type, dPosConfigurationSetDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Change POS configuration item saga
export function* dPosConfigurationEditItemWorker (actionObject:{type: string, payload: { itemObject: typeEditPosConfigurationItemObject, filters: typePosConfigurationFilters}}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(editPosConfigurationItem, { itemObject: actionObject.payload.itemObject})

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({ filters: actionObject.payload.filters})

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dPosConfigurationEditItemWatcher () {
    yield takeLatest(dPosConfigurationEditItemSagaAC.type, dPosConfigurationEditItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Add product item saga
export function* dPosConfigurationAddItemWorker (actionObject:{type: string, payload: { itemObject: typeAddPosConfigurationItemObject, filters: typePosConfigurationFilters}}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(addPosConfigurationItem, { itemObject: actionObject.payload.itemObject})

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_ADD_ITEM')

        yield getData({ filters: actionObject.payload.filters})

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dPosConfigurationAddItemWatcher () {
    yield takeLatest(dPosConfigurationAddItemSagaAC.type, dPosConfigurationAddItemWorker)
}



// ---------------------------------------------------------------------------------------------------------------------
// Delete product item saga
export function* dPosConfigurationDeleteItemWorker (actionObject:{type: string, payload: { itemId: string, filters:typePosConfigurationFilters}}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(deletePosConfigurationItem, { itemId: actionObject.payload.itemId})

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_DELETE_ITEM')

        yield getData({ filters: actionObject.payload.filters})

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dPosConfigurationDeleteItemWatcher () {
    yield takeLatest(dPosConfigurationDeleteItemSagaAC.type, dPosConfigurationDeleteItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Delete product item saga
export function* dPosConfigurationGetFullItemWorker (actionObject:{type: string, payload: { itemId: string}}) {

    let response = yield call(getPosFullItem, { itemId: actionObject.payload.itemId})

    if (response.status === 200) {

        yield put(dPosConfigurationSetFullDetailItemAC(response.data))

    } else {
        yield errorGenerator(response)
    }
}

export function* dPosConfigurationGetFullItemWatcher () {
    yield takeLatest(dPosConfigurationGetFullItemSagaAC.type, dPosConfigurationGetFullItemWorker)
}
